import { API_GATEWAY_URL } from '../constants/config';
import { withStandardHandlers } from './utils';
/**
 * Get service status. Even if the user is not logged in, this function can be called.
 *
 * @param token Access token
 */
export const getServiceStatus = (token) => {
    const fn = () => fetch(token ? `${API_GATEWAY_URL}/authorized/service-status` : `${API_GATEWAY_URL}/service-status`, {
        method: 'GET',
        headers: token ? { 'X-Authorization': `Bearer ${token}` } : {},
    });
    return withStandardHandlers(fn, 'errors.serviceStatus.fetch')();
};
/**
 * Get tutorial video config.
 *
 * @param token Access token
 */
export const getTutorialVideoConfig = (token) => {
    const fn = () => fetch(`${API_GATEWAY_URL}/tutorial-videos-config`, {
        method: 'GET',
        headers: token ? { 'X-Authorization': `Bearer ${token}` } : {},
    });
    return withStandardHandlers(fn, 'errors.tutorialVideoConfig.fetch')();
};
/**
 * Get feature flags. Even if the user is not logged in, this function can be called.
 *
 */
export const getFeatureFlags = () => {
    const fn = () => fetch(`${API_GATEWAY_URL}/feature-flags`, {
        method: 'GET',
    });
    return withStandardHandlers(fn, 'errors.featureFlags.fetch')();
};
